import { jobTypeOptions } from "../../PlacementCandidate/constants";
import { JobType } from "../../PlacementCandidate/types";
import { type PlacementWithDetails } from "../api/useFetchPaginatedPlacements";
import { type TransparencyPayRate } from "../types/payRate";

export function getLowestMinYearsOfExperience(
  transparencyPayRates: TransparencyPayRate[],
  jobType: JobType
) {
  return transparencyPayRates
    .filter((payRate) => {
      return payRate.jobTypes.includes(jobType);
    })
    .reduce((min, payRate) => {
      return Math.min(min, payRate.minYearsOfExperience);
    }, Number.POSITIVE_INFINITY);
}

export function isJobTypeOffered(params: {
  jobType: JobType;
  placement: Pick<PlacementWithDetails, "jobShifts">;
  transparencyPayRates: TransparencyPayRate[];
}) {
  const { jobType, placement, transparencyPayRates } = params;

  return (
    (placement?.jobShifts.some((jobShift) => jobShift.jobType === jobType) ?? false) &&
    transparencyPayRates.some((payRate) => payRate.jobTypes.includes(jobType))
  );
}

export function getOfferedJobTypes(params: {
  placement: Pick<PlacementWithDetails, "jobShifts">;
  transparencyPayRates: TransparencyPayRate[];
}) {
  const { placement, transparencyPayRates } = params;
  return jobTypeOptions
    .filter((jobTypeOption) => jobTypeOption.value !== JobType.WEEKEND_WARRIOR)
    .filter((jobTypeOption) =>
      isJobTypeOffered({
        jobType: jobTypeOption.value,
        placement,
        transparencyPayRates,
      })
    )
    .map((jobTypeOption) => jobTypeOption.value);
}
